module.exports = __webpack_public_path__ + "static/img/send.477d9051.png";